import React, { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles(theme => ({
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

function Updates({ updates }) {
  const classes = useStyles();

  return (
    <Fragment>
      <CssBaseline />
      <div className={classes.footer}>
        <Container maxWidth="sm">
          <Typography variant="h6" align="center" gutterBottom>Atualizações do Data Hodor!</Typography>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableBody>
                  {
                    updates.map(update => (
                      <TableRow key={update.id}>
                        <TableCell align="right">{update.date}</TableCell>
                        <TableCell align="left">{update.text}</TableCell>
                      </TableRow>
                    ))
                  }
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </div>
    </Fragment>
  );
}

export default Updates;